import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllTags(_obj, params) {
    const res = await axios.get('api/contacts/tags/', { params });
    return res.data;
  },
  async createTag(_obj, data) {
    return axios.post('api/contacts/tags/', data);
  },
  async updateTag(_obj, { id, data }) {
    return axios.patch(`api/contacts/tags/${id}/`, data);
  },
  async deleteTag(_obj, id) {
    return axios.delete(`api/contacts/tags/${id}/`);
  },
};

export const tag = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
